var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._32WU4Sxl-index-module-logo{margin-bottom:20px}._1e0M6ocT-index-module-sign-in-page{background-color:#067370;height:100%}._2K4WHQAd-index-module-col:first-child{background-color:#fff;padding-bottom:25px;padding-top:25px}._2K4WHQAd-index-module-col:last-child{color:#fff;font-size:26px;padding-top:50px}@media only screen and (min-width:576px){._1e0M6ocT-index-module-sign-in-page{background:linear-gradient(90deg,#067370 50%,#fff 0);color:#000;height:100%}.c5m2nUx_-index-module-main-container-wrapper{background-image:url(" + escape(require("./bg-bricks.svg")) + ");background-repeat:no-repeat;background-size:50% auto}._2K4WHQAd-index-module-col:last-child{font-size:28px;padding-left:5%;padding-top:150px}._2K4WHQAd-index-module-col:first-child{padding:75px 5% 0 8%}}", ""]);

// exports
exports.locals = {
	"primary": "#067370",
	"logo": "_32WU4Sxl-index-module-logo",
	"sign-in-page": "_1e0M6ocT-index-module-sign-in-page",
	"signInPage": "_1e0M6ocT-index-module-sign-in-page",
	"col": "_2K4WHQAd-index-module-col",
	"main-container-wrapper": "c5m2nUx_-index-module-main-container-wrapper",
	"mainContainerWrapper": "c5m2nUx_-index-module-main-container-wrapper"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/pages/SignIn/index.module.scss
// module id = 1203
// module chunks = 0